module.exports = __webpack_public_path__ + "static/media/Gb5.320163f1.mp3";